import { getApiUrl } from "../config";
import { getRandomNumber } from "../utils/helper";
import { post } from "./axiosRequest";
import axios from "axios";

export const createFileUpload = async ({ data, fileType = 1 }) => {
  try {
    const url = `${
      getApiUrl().fileUploadURL
    }/api/file/uploadfiles?filetype=${fileType}`;
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    return await post(url, data, {
      headers: headers,
    });
  } catch (err) {
    return err;
  }
};

export const fileUpload = async (file, isScorm = false) => {
  console.log("file", file);
  try {
    // const fileName = getRandomNumber() + "." + file?.name?.split(".").pop();
    let originalFileName = file?.name;
    if (originalFileName) {
      const ext = originalFileName?.split(".")?.pop();
      let baseName = originalFileName?.substring(0, originalFileName?.lastIndexOf("."));
      baseName = baseName?.replace(/[^a-zA-Z0-9-_ ]/g, "");
      if (baseName?.length > 235) {
        baseName = baseName?.substring(0, 235);
      }
      originalFileName = `${baseName}.${ext}`;
    }
    // const uniquePrefix = getRandomNumber() + "." + file?.name?.split(".").pop();
    const uniquePrefix = getRandomNumber();
    const fileName = `${uniquePrefix}${"_unique_"}${originalFileName}`;
    const type = file?.type;
    const preSignedS3Url = `${getApiUrl().adminApiUrl}/File/GetPreSignedS3Url`;
    const reqBody = {
      objects: [
        {
          objectKey: fileName,
          contentType: type,
        },
      ],
    };
    const reqBodyisScorm = {
      objects: [
        {
          objectKey: fileName,
          contentType: type,
        },
      ],
      fileType: 4,
    };
    const s3Response = await post(
      preSignedS3Url,
      isScorm ? reqBodyisScorm : reqBody,
      {
        headers: { Authorization: localStorage.getItem("id_token") },
      }
    );
    const { data: s3Data, status } = s3Response;
    if (!s3Data && status !== 200) {
      throw new Error("URL not dound");
    }
    const { preSignedUrls } = s3Data;

    const options = {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": type,
        "x-amz-acl": isScorm ? "private" : "public-read",
      },
    };
    const url = preSignedUrls[0]?.preSignedUrl;
    if (file) {
      const res = await fetch(url, options);
      if (res) {
        return preSignedUrls;
      }
    }
  } catch (err) {
    return err;
  }
};

// export const fileUpload = async (formDataState) => {
//   try {
//     const filesData = [];
//     formDataState?.forEach(async (file) => {
//       const fileName = getRandomNumber() + "." + file?.name?.split(".").pop();
//       const type = file?.type;

//       const preSignedS3Url = `${
//         getApiUrl().adminApiUrl
//       }/File/GetPreSignedS3Url`;
//       const reqBody = {
//         objects: [
//           {
//             objectKey: fileName,
//             contentType: type,
//           },
//         ],
//       };
//       const s3Response = await post(preSignedS3Url, reqBody, {
//         headers: { Authorization: localStorage.getItem("id_token") },
//       });
//       const { data: s3Data, status } = s3Response;
//       if (!s3Data && status !== 200) {
//         throw new Error("URL not dound");
//       }
//       const { preSignedUrls } = s3Data;
//       // Set up options for the PUT request
//       const options = {
//         method: "PUT",
//         body: file,
//         headers: {
//           "Content-Type": type,
//           "x-amz-acl": "public-read",
//         },
//       };
//       const url = preSignedUrls[0]?.preSignedUrl;
//       if (file) {
//         const res = await fetch(url, options);
//         if (res) {
//           return preSignedUrls;
//         }
//       }
//     });
//     // if (filesData?.length === formDataState?.length) {
//     //   return filesData;
//     // }
//   } catch (err) {
//     return err;
//   }
// };

// export const fileUpload = async ({ data, fileName, type }) => {
//   try {
//     const preSignedS3Url = `${getApiUrl().adminApiUrl}/File/GetPreSignedS3Url`;
//     const reqBody = {
//       objects: [
//         {
//           objectKey: fileName,
//           contentType: type,
//         },
//       ],
//     };
//     const s3Response = await post(preSignedS3Url, reqBody, {
//       headers: { Authorization: localStorage.getItem("id_token") },
//     });
//     const { data: s3Data, status } = s3Response;
//     if (!s3Data && status !== 200) {
//       throw new Error("URL not dound");
//     }
//     const { preSignedUrls } = s3Data;

//     // Set up options for the PUT request
//     const options = {
//       method: "PUT",
//       body: data,
//       headers: {
//         "Content-Type": type,
//         "x-amz-acl": "public-read",
//       },
//     };
//     const url = preSignedUrls[0]?.preSignedUrl;
//     if (data) {
//       const res = await fetch(url, options);
//       if (res) {
//         return preSignedUrls;
//       }
//     }
//     return [];
//   } catch (err) {
//     return err;
//   }
// };

export const fileUploads = async (file) => {
  try {
    // Sanitize filename: replace spaces with underscores and remove special characters
    const sanitizeFileName = (name) => {
      return name
        .replace(/\s+/g, "_") // Replace spaces with underscores
        .replace(/[^a-zA-Z0-9-_\.]/g, "") // Remove special characters
        .toLowerCase();
    };

    const originalName = file.name.split(".").slice(0, -1).join(".");
    const sanitizedBaseName = sanitizeFileName(originalName);
    const originalExtension = file.name.split(".").pop().toLowerCase();
    const finalExtension =
      originalExtension === "jpeg" ? "jpg" : originalExtension;

    const fileName = `${sanitizedBaseName}_${Date.now()}.${finalExtension}`;

    // Rest of your existing upload logic
    const preSignedS3Url = `${getApiUrl().adminApiUrl}/File/GetPreSignedS3Url`;
    const reqBody = {
      objects: [
        {
          objectKey: fileName,
          contentType:
            file.type || `image/${finalExtension === "png" ? "png" : "jpeg"}`,
        },
      ],
    };

    const s3Response = await post(preSignedS3Url, reqBody, {
      headers: { Authorization: localStorage.getItem("id_token") },
    });

    const { data: s3Data } = s3Response;
    const { preSignedUrls } = s3Data;

    const options = {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": file.type,
        "x-amz-acl": "public-read",
      },
    };

    await fetch(preSignedUrls[0]?.preSignedUrl, options);
    return preSignedUrls;
  } catch (err) {
    throw new Error("File upload failed");
  }
};
